import React, { Component } from "react"
import CategoryFilter from "../Filters/CategoryFilter"
import PriceFilter from "../Filters/PriceFilter"
import ProductList from "../ProductList/ProductList"
import Utils from "../../../utils/node.utils"
import axios from "axios"
import { store as tStore, setT } from "../../Store/Store"

const defaultDomain = [0, 1000]

export default class Shop extends Component {
  state = {
    textSearchValue: undefined,
    textSearchIDs: undefined,
    subCategories: {},
    priceDomain: defaultDomain.slice(),
    priceValues: defaultDomain.slice(),
  }

  componentDidMount() {
    const { subCategories } = this.props
    const domain = this.getDomain()

    this.unsubscribe = tStore.subscribe(this.storeUpdate)
    this.storeUpdate(this.searchIfValueSet)

    this.setState({
      subCategories: subCategories,
      priceDomain: domain,
      priceValues: domain,
    })
  }

  componentDidUpdate() {
    const { tsValue } = this.props
    const { t, textSearchValue } = this.state

    if (textSearchValue !== tsValue) {
      if (!tsValue || tsValue === "") {
        this.setState({
          textSearchValue: tsValue,
          textSearchIDs: {},
        })
        return
      }
      if (t) {
        this.searchProducts()
      }
    }
  }

  componentWillUnmount() {
    Utils.CancelToken(this.cancelToken)
    Utils.Unsubscribe(this.unsubscribe)
  }

  storeUpdate = cb => {
    const storeState = tStore.getState()

    if (storeState.t) {
      this.setState(
        {
          t: storeState.t,
        },
        cb
      )
    }
  }

  searchIfValueSet = () => {
    const { tsValue } = this.props
    if (tsValue) {
      this.searchProducts()
    }
  }

  getMaincategories = () => {
    const { mainCategories } = this.props
    if (mainCategories) {
      return mainCategories
    }
    return {}
  }

  searchProducts = () => {
    const { tsValue } = this.props
    const { t } = this.state

    if (!t) {
      console.warn("Cannot search products, not authenticated")
      return
    }

    if (this.loading) {
      return
    }

    this.loading = true
    this.cancelToken = axios.CancelToken.source()
    axios
      .get(
        `/enjocommerce/v1/products?search=${encodeURI(tsValue)}`,
        Utils.RequestHeaders(t, this.cancelToken)
      )
      .then(data => {
        const products = {}
        this.loading = false

        if (data.data.pages) {
          for (let i in data.data.pages) {
            const product = data.data.pages[i]
            products[product.id] = true
          }
        }

        this.setState({
          textSearchValue: tsValue,
          textSearchIDs: products,
        })
      })
      .catch(err => {
        this.loading = false
        if (Utils.LogAxiosError(err)) {
          return
        }
        if (err.response) {
          if (err.response.status == 401) {
            tStore.dispatch(setT(""))
          }
        }
      })
  }

  reduceDomain = (domain, product) => {
    const productPrice = Utils.GetProductPrice(product.node.item)

    if (!productPrice) {
      console.error("Product does not have a price: ", product.node.item)
      return domain
    }

    const productPriceFloat = parseFloat(productPrice.value)

    if (productPriceFloat - 1 < domain[0]) {
      domain[0] = productPriceFloat - 1
    }
    if (productPriceFloat + 1 > domain[1]) {
      domain[1] = productPriceFloat + 1
    }
    return domain
  }

  getDomain = () => {
    const { products } = this.props

    if (!products || products.length === 0) {
      return defaultDomain.slice()
    }

    const product = products[0].node.item
    const productPrice = Utils.GetProductPrice(product)
    const productPriceFloat = parseFloat(productPrice.value)
    const initDomain = [productPriceFloat - 1, productPriceFloat + 1]
    const retval = this.props.products
      .reduce(this.reduceOnCategoryFilter, [])
      .reduce(this.reduceDomain, initDomain.slice())
    return retval
  }

  hasCategoryFilterSet = () => {
    const { subCategories } = this.state
    if (this.hasMainCategories()) {
      return true
    }
    for (var category in subCategories) {
      if (subCategories[category]) {
        return true
      }
    }
    return false
  }

  hasPriceFilterSet = () => {
    const { priceDomain, priceValues } = this.state

    if (priceDomain[0] != priceValues[0]) {
      return true
    }
    if (priceDomain[1] != priceValues[1]) {
      return true
    }
    return false
  }

  hasTextsearchSet = () => {
    const { textSearchIDs, textSearchValue } = this.state
    if (textSearchIDs && textSearchValue != "") {
      return true
    }
    return false
  }

  hasMainCategories = () => {
    const { mainCategories } = this.props
    if (mainCategories && Object.keys(mainCategories).length != 0) {
      return true
    }
    return false
  }

  reduceOnCategoryFilter = (productList, product) => {
    const {
      props: { mainCategories },
      state: { subCategories },
    } = this

    for (let category in mainCategories) {
      if (mainCategories[category]) {
        let match = false
        for (let productCategory in product.node.item.categories) {
          if (
            Utils.GetContentKeyValue(
              product.node.item.categories[productCategory].content,
              "name"
            ) === category
          ) {
            match = true
            break
          }
        }
        if (!match) {
          return productList
        }
      }
    }

    let hasSubCategory = false
    for (let category in subCategories) {
      if (subCategories[category]) {
        hasSubCategory = true
        for (let productCategory in product.node.item.categories) {
          if (
            Utils.GetContentKeyValue(
              product.node.item.categories[productCategory].content,
              "name"
            ) === category
          ) {
            productList.push(product)
            return productList
          }
        }
      }
    }
    if (!hasSubCategory) {
      productList.push(product)
    }

    return productList
  }

  reduceOnPriceFilter = (productList, product) => {
    const { priceValues } = this.state
    const productPrice = Utils.GetProductPrice(product.node.item)

    if (!productPrice) {
      console.error("Product does not have a price: ", product.node.item)
      return productList
    }

    const productPriceFloat = parseFloat(productPrice.value)

    if (
      productPriceFloat >= priceValues[0] &&
      productPriceFloat <= priceValues[1]
    ) {
      productList.push(product)
    }
    return productList
  }

  reduceOnTextSearch = (productList, product) => {
    const { textSearchIDs } = this.state
    if (textSearchIDs[product.node.item.id]) {
      productList.push(product)
    }
    return productList
  }

  reduceOnPrivate = (productList, product) => {
    if (!product.node.item.private) {
      productList.push(product)
    }
    return productList
  }

  getProducts = () => {
    const { products } = this.props
    let returnProducts = products

    if (this.hasTextsearchSet()) {
      returnProducts = returnProducts.reduce(this.reduceOnTextSearch, [])
    }
    if (this.hasCategoryFilterSet()) {
      returnProducts = returnProducts.reduce(this.reduceOnCategoryFilter, [])
    }
    if (this.hasPriceFilterSet()) {
      returnProducts = returnProducts.reduce(this.reduceOnPriceFilter, [])
    }

    return returnProducts.reduce(this.reduceOnPrivate, [])
  }

  onCategoryClick = (category, checked) => {
    const { subCategories } = this.state
    subCategories[category] = checked
    this.setState({ subCategories: subCategories })

    if (checked) {
      Utils.DoGoogleTagEvent({
        dataLayer: {
          event: "viewCategory",
        },
      })
    }
  }

  onPriceFilterChange = values => {
    this.setState({ priceValues: values })
  }

  render() {
    const {
      breadCrumb,
      language,
      contentMap,
      commonContentMap,
      search,
    } = this.props
    const { subCategories, priceDomain } = this.state

    return (
      <div className="container">
        <div className="row">
          <div className="sidebar col-xl-3 col-lg-4 order-lg-1">
            <CategoryFilter
              categories={subCategories}
              onCategoryClick={this.onCategoryClick}
              language={language}
              contentMap={contentMap}
            />
            <PriceFilter
              domain={priceDomain}
              onPriceFilterChange={this.onPriceFilterChange}
              contentMap={contentMap}
            />
          </div>
          <ProductList
            products={this.getProducts()}
            breadCrumb={breadCrumb}
            language={language}
            contentMap={contentMap}
            commonContentMap={commonContentMap}
            search={search}
          />
        </div>
      </div>
    )
  }
}
